// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.

export const EXPECTED_QUICK_SPECS = [
	'odometer',
	'cityFuelEconomy',
	'highwayFuelEconomy',
	'exteriorColor',
	'interiorColor',
	'normalExteriorColor',
	'normalInteriorColor',
	'bodyStyle',
	'transmission',
	'driveLine',
	'engine',
	'engineSize',
	'combinedFuelEfficiency',
	'range',
	'batteryWarranty',
	'horsePower',
	'kWhCombinedFuelEfficiency'
];

export const EV_QUICK_SPECS = [
	// TODO: remove range spec once IDC flag is permanent (we switched to using 'electricRange' as attr key)
	{
		key: 'range',
		titleLabel: 'EV_RANGE_SPEC_TITLE_VERBIAGE',
		detailLabel: 'EV_RANGE_SPEC_DETAILS_VERBIAGE',
		value: null
	},
	{
		key: 'combinedFuelEfficiency',
		titleLabel: 'EV_COMBINEDFUELEFFICIENCY_SPEC_TITLE_VERBIAGE',
		detailLabel: 'EV_COMBINEDFUELEFFICIENCY_SPEC_DETAILS_VERBIAGE',
		value: null
	},
	{
		key: 'electricRange',
		titleLabel: 'EV_RANGE_SPEC_TITLE_VERBIAGE',
		detailLabel: 'EV_RANGE_SPEC_DETAILS_VERBIAGE',
		value: null
	},
	{
		key: 'kWhCombinedFuelEfficiency',
		titleLabel: 'EV_KWH_COMBINEDFUELEFFICIENCY_SPEC_TITLE_VERBIAGE',
		detailLabel: 'EV_KWH_COMBINEDFUELEFFICIENCY_SPEC_DETAILS_VERBIAGE',
		value: null
	}
];

export const SEATING_SPEC_ID = 2050;
export const NORMALIZED_TRANSMISSION_SPEC_ID = 340;
export const NORMALIZED_DRIVELINE_SPEC_ID = 500;
export const EQUIPMENT_COMBINED_FUEL_ECONOMY_SPEC_ID = 551;
export const EQUIPMENT_RANGE_SPEC_ID = 115;
export const EQUIPMENT_EV_TOTAL_RANGE_SPEC_ID = 116;
export const EQUIPMENT_BATTERY_WARRANTY_SPEC_ID = 5220;
export const EQUIPMENT_EV_TYPE_SPEC_ID = 113;
export const EQUIPMENT_EV_HORSE_POWER_SPEC_ID = 55;
export const EQUIPMENT_KWH_FUEL_ECONOMY_COMBINED_SPEC_ID = 5530;

export const FLAG_ENABLE_EV_DETAIL_LINK = 'show-ev-detail-link';
export const FLAG_USE_QUICK_SPECS_FROM_IDC = 'use-quick-specs-from-idc';
export const FLAG_ENABLE_LABEL_PLACEHOLDER = 'enable-label-placeholder';

export const quickSpecIDCLabelMapping = {
	exteriorColor: {
		placeHolderLabel: 'EXTERIOR_COLOR_PLACEHOLDER',
		selector: '{{exteriorColor}}'
	},
	interiorColor: {
		placeHolderLabel: 'INTERIOR_COLOR_PLACEHOLDER',
		selector: '{{interiorColor}}'
	},
	odometer: {
		placeHolderLabel: 'ODOMETER_PLACEHOLDER',
		selector: '{{odometer}}'
	},
	bodyStyle: {
		placeHolderLabel: 'BODYSTYLE_PLACEHOLDER',
		selector: '{{bodyStyle}}'
	},
	fuelEconomy: {
		placeHolderLabel: 'FUEL_ECONOMY_PLACEHOLDER',
		selector: '{{fuelEconomy}}'
	},
	electricRange: {
		placeHolderLabel: 'EV_RANGE_PLACEHOLDER',
		selector: '{{range}}'
	},
	totalRange: {
		placeHolderLabel: '',
		selector: ''
	},
	combinedFuelEfficiency: {
		placeHolderLabel: 'EV_MPGE_PLACEHOLDER',
		selector: '{{combinedFuelEfficiency}}'
	},
	kWhCombinedFuelEfficiency: {
		placeHolderLabel: 'EV_KWH_PLACEHOLDER',
		selector: '{{evKWH}}'
	},
	batteryWarranty: {
		placeHolderLabel: 'BATTERY_WARRANTY_PLACEHOLDER',
		selector: '{{batteryWarranty}}'
	},
	transmission: {
		placeHolderLabel: 'TRANSMISSION_PLACEHOLDER',
		selector: '{{transmission}}'
	},
	driveLine: {
		placeHolderLabel: 'DRIVE_LINE_PLACEHOLDER',
		selector: '{{driveLine}}'
	},
	horsePower: {
		placeHolderLabel: 'HORSEPOWER_PLACEHOLDER',
		selector: '{{horsepower}}'
	},
	engine: {
		placeHolderLabel: 'ENGINE_PLACEHOLDER',
		selector: '{{engine}}'
	},
	maxSeatingCapacity: {
		placeHolderLabel: 'BODY_SEATING_PLACEHOLDER',
		selector: '{{body/seating}}'
	},
	vin: {
		placeHolderLabel: 'VIN_PLACEHOLDER',
		selector: '{{vin}}'
	},
	year: {
		placeHolderLabel: 'YEAR_PLACEHOLDER',
		selector: '{{year}}'
	},
	trim: {
		placeHolderLabel: 'TRIM_ATTRIBUTE_PLACEHOLDER',
		selector: '{{trim}}'
	},
	stockNumber: {
		placeHolderLabel: 'STOCK_NUMBER_PLACEHOLDER',
		selector: '{{stockNumber}}'
	},
	model: {
		placeHolderLabel: 'MODEL_ATTRIBUTE_PLACEHOLDER',
		selector: '{{model}}'
	},
	modelCode: {
		placeHolderLabel: 'MODEL_CODE_PLACEHOLDER',
		selector: '{{modelCode}}'
	},
	doors: {
		placeHolderLabel: 'DOORS_PLACEHOLDER',
		selector: '{{doors}}'
	},
	fuelType: {
		placeHolderLabel: 'FUEL_TYPE_PLACEHOLDER',
		selector: '{{fuelType}}'
	},
	cab: {
		placeHolderLabel: 'CAB_PLACEHOLDER',
		selector: '{{cab}}'
	},
	make: {
		placeHolderLabel: 'MAKE_ATTRIBUTE_PLACEHOLDER',
		selector: '{{make}}'
	}
};
